import React, { Component } from "react";
import "./FeedbackCreation.css";
import Page from "../2/Controls/Page";
import PageSection from "../2/Controls/PageSection";
import Input from "../2/Controls/Input";
import Button from "../2/Controls/Button";
import NewButton from "../2/Controls/NewButton";
import Icon from "../2/Controls/Icon";
import NewImageButton from "../2/Controls/NewImageButton";
import Modal from 'react-responsive-modal';
import { SketchPicker } from "react-color";
import ImageUploader from "../2/Controls/ImageUploader";

class FeedbackCreation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      currentStep: 1,
      title: "",
      description: "",
      questions: [],
      validityFrom: new Date().toISOString().split('T')[0],
      validityTo: new Date().toISOString().split('T')[0],
      startTime: { HH: '', MM: '', AMPM: '' },
      endTime: { HH: '', MM: '', AMPM: '' },
      status: "Active",
      emojiSearchTerm: {},
      showEmojiPicker: {},
      starCount: {},
      key: "",
      titleError: "",
      validityFromError: "",
      validityToError: "",
      startTimeError: "",
      endTimeError: "",
      header: {
        showHeader:false,
        text: "",
        backgroundColor: "#FFFFFF",
        textColor: "#000000",
        image: null // Single image object or null
      },
      footer: {
        showFooter:false,
        text: "",
        backgroundColor: "#FFFFFF",
        textColor: "#000000",
        image: null // Single image object or null
      },
      showColorPicker: false,
      selectedColor: "#FFFFFF",
      colorPickerTarget: null,
    };
  }

  componentDidMount() {
    if (this.props.location.state && this.props.location.state.data) {
      const formData = this.props.location.state.data;
      const questions = formData.Questions || [];
    
    // Map API question fields to component's expected format
    const mappedQuestions = questions.map((q) => ({
      question: q.Question || "",           // Map Question -> question
      answerType: q.AnswerType || "text",   // Map AnswerType -> answerType
      mandatory: q.Mandatory || false,      // Map Mandatory -> mandatory
      options: q.Options || [],             // Map Options -> options
      starCount: q.starCount || 5           // Keep starCount
    }));

    // Initialize starCount state for each question
    const starCount = {};
    mappedQuestions.forEach((q, index) => {
      starCount[index] = q.starCount || 5;
    });


      // Convert single image to object for ImageUploader
      const headerImage = formData.Header && formData.Header.Image && formData.Header.Image.Url 
        ? {
            ImageName: formData.Header.Image.FileName || 'header-image',
            ImagePath: formData.Header.Image.Url,
            FileType: formData.Header.Image.FileType || 'image/jpeg'
          }
        : null;

      const footerImage = formData.Footer && formData.Footer.Image && formData.Footer.Image.Url
        ? {
            ImageName: formData.Footer.Image.FileName || 'footer-image',
            ImagePath: formData.Footer.Image.Url,
            FileType: formData.Footer.Image.FileType || 'image/jpeg'
          }
        : null;

      this.setState({
        key: formData.key,
        title: formData.Title || "",
        description: formData.Description || "",
        questions: mappedQuestions,
        starCount: starCount,
        validityFrom: formData.ValidityFrom || this.state.validityFrom,
        validityTo: formData.ValidityTo || this.state.validityTo,
        startTime: formData.StartTime || this.state.startTime,
        endTime: formData.EndTime || this.state.endTime,
        status: formData.Status || "Active",
        header: {
          ...formData.Header || this.state.header,
          image: headerImage
        },
        footer: {
          ...formData.Footer || this.state.footer,
          image: footerImage
        },
      });
    }
  }

  // Complete emoji list with labels
  emojiList = [
    { emoji: "😊", label: "Smile" },
    { emoji: "😄", label: "Happy" },
    { emoji: "😍", label: "Love" },
    { emoji: "🤔", label: "Thinking" },
    { emoji: "😢", label: "Sad" },
    { emoji: "😡", label: "Angry" },
    { emoji: "😎", label: "Cool" },
    { emoji: "🥳", label: "Celebrate" },
    { emoji: "😇", label: "Innocent" },
    { emoji: "🤗", label: "Hug" },
    { emoji: "😱", label: "Scream" },
    { emoji: "🥺", label: "Pleading" },
    { emoji: "😤", label: "Frustrated" },
    { emoji: "🤪", label: "Crazy" },
    { emoji: "😜", label: "Wink" },
    { emoji: "🤩", label: "Starstruck" },
    { emoji: "🤯", label: "Mind Blown" },
    { emoji: "😳", label: "Flushed" },
    { emoji: "🥰", label: "Heart Eyes" },
    { emoji: "🤤", label: "Drooling" },
    { emoji: "😏", label: "Smirk" },
    { emoji: "😈", label: "Devil" },
    { emoji: "👏", label: "Clap" },
    { emoji: "👍", label: "Thumbs Up" },
    { emoji: "👎", label: "Thumbs Down" },
    { emoji: "🙌", label: "Raise Hands" },
    { emoji: "👋", label: "Wave" },
    { emoji: "💪", label: "Flex" },
    { emoji: "❤️", label: "Heart" },
    { emoji: "🧡", label: "Orange Heart" },
    { emoji: "💛", label: "Yellow Heart" },
    { emoji: "💚", label: "Green Heart" },
    { emoji: "💙", label: "Blue Heart" },
    { emoji: "💜", label: "Purple Heart" },
    { emoji: "🖤", label: "Black Heart" },
    { emoji: "⭐", label: "Star" },
    { emoji: "🌟", label: "Glowing Star" },
    { emoji: "✨", label: "Sparkles" },
    { emoji: "🔥", label: "Fire" },
    { emoji: "💯", label: "Hundred" },
    { emoji: "🎉", label: "Party" },
    { emoji: "🎊", label: "Confetti" },
    { emoji: "🎈", label: "Balloon" },
    { emoji: "🎁", label: "Gift" },
    { emoji: "🏆", label: "Trophy" },
    { emoji: "🏅", label: "Medal" },
    { emoji: "👑", label: "Crown" },
    { emoji: "💎", label: "Diamond" },
    { emoji: "🌺", label: "Flower" },
    { emoji: "🌸", label: "Cherry Blossom" },
    { emoji: "🌹", label: "Rose" },
    { emoji: "🌻", label: "Sunflower" },
    { emoji: "🌿", label: "Plant" },
    { emoji: "🍕", label: "Pizza" },
    { emoji: "🍔", label: "Burger" },
    { emoji: "🍟", label: "Fries" },
    { emoji: "🍫", label: "Chocolate" },
    { emoji: "🍦", label: "Ice Cream" },
    { emoji: "🍩", label: "Donut" },
    { emoji: "🍪", label: "Cookie" },
    { emoji: "☕", label: "Coffee" },
    { emoji: "⚽", label: "Soccer" },
    { emoji: "🏀", label: "Basketball" },
    { emoji: "⚾", label: "Baseball" },
    { emoji: "🎮", label: "Video Game" },
    { emoji: "🎵", label: "Music" },
    { emoji: "🎶", label: "Musical Notes" }
  ];

  // Most used emojis for default selection
  defaultEmojis = [
     { emoji: "😄", label: "Happy" },
    { emoji: "😊", label: "Smile" },
    { emoji: "😢", label: "Sad" },
      { emoji: "😡", label: "Angry" },
  ];

  handleFormChange = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  addQuestion = () => {
    const newQuestion = {
      question: "",
      answerType: "text",
      mandatory: false,
      options: [],
      starCount: 5
    };

    this.setState((prevState) => ({
      questions: [...prevState.questions, newQuestion],
      emojiSearchTerm: {
        ...prevState.emojiSearchTerm,
        [prevState.questions.length]: ""
      },
      showEmojiPicker: {
        ...prevState.showEmojiPicker,
        [prevState.questions.length]: false
      },
      starCount: {
        ...prevState.starCount,
        [prevState.questions.length]: 5
      }
    }));
  };

  updateQuestion = (questionIndex, field, value) => {
    const questions = [...this.state.questions];

    if (field === "starCount") {
      const starValue = parseInt(value) || 0;
      this.setState((prevState) => ({
        starCount: {
          ...prevState.starCount,
          [questionIndex]: starValue
        }
      }));
    }

    if (field === "answerType" && value === "star") {
      this.setState((prevState) => ({
        starCount: {
          ...prevState.starCount,
          [questionIndex]: 5
        }
      }));
    }

    if (field === "answerType" && value === "emoji") {
      const defaultOptions = this.defaultEmojis.map(emoji => ({
        label: emoji.emoji,
        value: emoji.label.toLowerCase().replace(/\s+/g, '_')
      }));

      questions[questionIndex] = {
        ...questions[questionIndex],
        options: defaultOptions,
        [field]: value
      };

      this.setState({ questions });
      return;
    }

    questions[questionIndex] = {
      ...questions[questionIndex],
      [field]: field === "starCount" ? parseInt(value) || 0 : value
    };

    this.setState({ questions });
  };

  removeQuestion = (questionIndex) => {
    this.setState((prevState) => {
      const newQuestions = prevState.questions.filter((_, index) => index !== questionIndex);

      const newEmojiSearchTerm = {};
      const newShowEmojiPicker = {};
      const newStarCount = {};

      newQuestions.forEach((_, index) => {
        newEmojiSearchTerm[index] = prevState.emojiSearchTerm[index] || "";
        newShowEmojiPicker[index] = prevState.showEmojiPicker[index] || false;
        newStarCount[index] = prevState.starCount[index] || 5;
      });

      return {
        questions: newQuestions,
        emojiSearchTerm: newEmojiSearchTerm,
        showEmojiPicker: newShowEmojiPicker,
        starCount: newStarCount
      };
    });
  };

  addOption = (questionIndex) => {
    const questions = [...this.state.questions];
    questions[questionIndex].options = [
      ...questions[questionIndex].options,
      {
        label: "",
        value: ""
      }
    ];

    this.setState({ questions });
  };

  updateOption = (questionIndex, optionIndex, field, value) => {
    const questions = [...this.state.questions];
    questions[questionIndex].options[optionIndex] = {
      ...questions[questionIndex].options[optionIndex],
      [field]: value
    };

    this.setState({ questions });
  };

  removeOption = (questionIndex, optionIndex) => {
    const questions = [...this.state.questions];
    questions[questionIndex].options = questions[questionIndex].options.filter(
      (_, index) => index !== optionIndex
    );

    this.setState({ questions });
  };

  handleEmojiSearch = (questionIndex, searchTerm) => {
    this.setState((prevState) => ({
      emojiSearchTerm: {
        ...prevState.emojiSearchTerm,
        [questionIndex]: searchTerm
      }
    }));
  };

  toggleEmojiPicker = (questionIndex) => {
    this.setState((prevState) => ({
      showEmojiPicker: {
        ...prevState.showEmojiPicker,
        [questionIndex]: !prevState.showEmojiPicker[questionIndex]
      }
    }));
  };

  addEmojiOption = (questionIndex, emoji, label) => {
    const questions = [...this.state.questions];
    questions[questionIndex].options = [
      ...questions[questionIndex].options,
      {
        label: emoji,
        value: label.toLowerCase().replace(/\s+/g, '_')
      }
    ];

    this.setState({
      questions,
      showEmojiPicker: {
        ...this.state.showEmojiPicker,
        [questionIndex]: false
      }
    });
  };

  removeEmojiOption = (questionIndex, optionIndex) => {
    const questions = [...this.state.questions];
    questions[questionIndex].options = questions[questionIndex].options.filter(
      (_, index) => index !== optionIndex
    );

    this.setState({ questions });
  };

  validateStep1 = () => {
    let titleError = "";

    if (this.state.title === "") {
      titleError = "Please enter title";
    }

    this.setState({
      titleError: titleError,
    });

    const cleanedQuestions = this.state.questions.map((question) => {
      const { starCount, ...cleanQuestion } = question;
      return {
        Question: cleanQuestion.question || "",
        AnswerType: cleanQuestion.answerType || "text",
        Mandatory: cleanQuestion.mandatory || false,
        Options: cleanQuestion.options || [],
        starCount: starCount || 5
      };
    });

    const allQuestionsEmpty = cleanedQuestions.every(
      (q) => !q.Question || q.Question.trim() === ""
    );

    if (allQuestionsEmpty) {
      alert("Please provide at least one question");
      return false;
    }

    if (titleError !== "") {
      return false;
    }

    return true;
  };

  validateStep2 = () => {
    return true;
  };

  goToNextStep = () => {
    if (this.validateStep1()) {
      this.setState({ currentStep: 2 });
    }
  };

  goToPreviousStep = () => {
    this.setState({ currentStep: 1 });
  };

  // Image Upload Handlers for Header
  handleHeaderImageChange = (images) => {
    // ImageUploader passes an array, we take the first image or null
    const image = images && images.length > 0 ? images[0] : null;
    this.setState({
      header: {
        ...this.state.header,
        image: image
      }
    });
  };

  // Image Upload Handlers for Footer
  handleFooterImageChange = (images) => {
    const image = images && images.length > 0 ? images[0] : null;
    this.setState({
      footer: {
        ...this.state.footer,
        image: image
      }
    });
  };

  onSave = async () => {
    const cleanedQuestions = this.state.questions.map((question) => {
      const { starCount, ...cleanQuestion } = question;

      if (cleanQuestion.options) {
        cleanQuestion.options = cleanQuestion.options.map(option => ({
          label: option.label || "",
          value: option.value || ""
        }));
      }

      return {
        Question: cleanQuestion.question || "",
        AnswerType: cleanQuestion.answerType || "text",
        Mandatory: cleanQuestion.mandatory || false,
        Options: cleanQuestion.options || [],
        starCount: starCount || 5
      };
    });

    // Extract image data from single image object
    const headerImage = this.state.header.image 
      ? {
          Url: this.state.header.image.ImagePath || "",
          FileType: this.state.header.image.FileType || "image/jpeg",
          FileName: this.state.header.image.ImageName || "header-image.jpg",
        }
      : {
          Url: "",
          FileType: "",
          FileName: "",
        };

    const footerImage = this.state.footer.image
      ? {
          Url: this.state.footer.image.ImagePath || "",
          FileType: this.state.footer.image.FileType || "image/jpeg",
          FileName: this.state.footer.image.ImageName || "footer-image.jpg",
        }
      : {
          Url: "",
          FileType: "",
          FileName: ""
        };

    const payload = {
      Title: this.state.title,
      Description: this.state.description,
      ValidityFrom: this.state.validityFrom,
      ValidityTo: this.state.validityTo,
      StartTime: this.state.startTime,
      EndTime: this.state.endTime,
      Status: this.state.status || "Active",
      Questions: cleanedQuestions,
      StoreID: this.props.user.store.key,
      Header: {
        ShowHeader:this.state.showHeader ||  false,
        Text: this.state.header.text || "",
        BackgroundColor: this.state.header.backgroundColor || "#FFFFFF",
        TextColor: this.state.header.textColor || "#000000",
        Image: headerImage
      },
      Footer: {
        ShowFooter:this.state.ShowFooter || false,
        Text: this.state.footer.text || "",
        BackgroundColor: this.state.footer.backgroundColor || "#FFFFFF",
        TextColor: this.state.footer.textColor || "#000000",
        Image: footerImage
      },
    };

    try {
      this.setState({ loading: true });
      const response = await this.props.saveFeedback(this.state.key, payload);

      if (response.code === "0") {
        alert("Feedback saved successfully");
        this.props.history.push({
          pathname: "/home/feedback/template",
        });
      } else {
        alert("Failed to save");
      }
    } catch (error) {
      alert("Failed to save");
      console.log("error", error);
    } finally {
      this.setState({ loading: false });
    }
  };

  onCancel = () => {
    this.props.history.push({
      pathname: "/home/feedback/template",
    });
  };

  // Color Picker Methods
  onShowColorPicker = (color, target) => {
    this.setState({
      showColorPicker: true,
      selectedColor: color || "#FFFFFF",
      colorPickerTarget: target
    });
  };

  onColorChangeComplete = (color) => {
    this.setState({ selectedColor: color.hex });
  };

  onColorSelected = () => {
    const { colorPickerTarget, selectedColor } = this.state;

    if (!colorPickerTarget) {
      this.setState({ showColorPicker: false });
      return;
    }

    // Update the appropriate color field based on target
    const [section, field] = colorPickerTarget.split('_');

    if (section === 'header') {
      this.setState({
        header: {
          ...this.state.header,
          [field]: selectedColor
        },
        showColorPicker: false,
        colorPickerTarget: null
      });
    } else if (section === 'footer') {
      this.setState({
        footer: {
          ...this.state.footer,
          [field]: selectedColor
        },
        showColorPicker: false,
        colorPickerTarget: null
      });
    }
  };

  renderStarRatingPreview = (questionIndex) => {
    const starCount = this.state.starCount[questionIndex] || 5;
    const stars = [];
    for (let i = 1; i <= starCount; i++) {
      stars.push(
        <span key={i} style={{ fontSize: '24px', marginRight: '4px' }}>
          ⭐
        </span>
      );
    }
    return (
      <div style={{ marginTop: '8px', padding: '8px', background: '#f8f9fa', borderRadius: '4px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <span style={{ fontSize: '14px', color: '#666' }}>Preview:</span>
          <div>{stars}</div>
          <span style={{ fontSize: '12px', color: '#999', marginLeft: '8px' }}>
            ({starCount} stars)
          </span>
        </div>
      </div>
    );
  };

  renderColorPickerControl() {
    return (
      <Modal open={this.state.showColorPicker} onClose={() => this.setState({ showColorPicker: false })} center>
        <div className="box-body" style={{ padding: '20px' }}>
          <SketchPicker
            color={this.state.selectedColor}
            onChangeComplete={this.onColorChangeComplete}
          />
        </div>
        <div className="box-footer" style={{ padding: '20px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
          <button
            type="button"
            className="btn btn-flat btn-md btn-default"
            onClick={() => this.setState({ showColorPicker: false })}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-flat btn-md btn-success"
            onClick={this.onColorSelected}
          >
            OK
          </button>
        </div>
      </Modal>
    );
  }

  renderStep1 = () => {
    // Prepare images array for ImageUploader (it expects an array)
    const headerImages = this.state.header.image ? [this.state.header.image] : [];
    const footerImages = this.state.footer.image ? [this.state.footer.image] : [];

    return (
      <div>
        <PageSection title="General Details">
          <div className="row">
            <div className="col-md-4">
              <Input
                type="text"
                label="Enter form title"
                onChange={(e) => { this.handleFormChange("title", e); this.setState({ titleError: "" }) }}
                value={this.state.title}
                isMandatory={true}
                error={this.state.titleError}
              />
            </div>
          </div>
        </PageSection>

        {/* Header Configuration */}
<PageSection title="Header Configuration">
  <div className="row">
    <div className="col-md-4">
       <Input
        type="switch"
        label="Show Header"
        value={this.state.header.showHeader || false}
        onChange={(e) => {
          this.setState({
            header: {
              ...this.state.header,
              showHeader: e
            }
          });
        }}
      />
    </div>

  </div>
  {this.state.header.showHeader && <div className="row">

    <div className="col-md-4">
      <Input
        type="text"
        label="Header Text"
        placeholder="Enter header text"
        value={this.state.header.text || ""}
        onChange={(e) => {
          this.setState({
            header: {
              ...this.state.header,
              text: e
            }
          });
        }}
      />
    </div>
   <div className="col-md-4">
  <div className="form-group">
    <label>Background Color</label>
    <div className="input-group">
      <input 
        className="form-control"
        value={this.state.header.backgroundColor || "#FFFFFF"}
        onChange={(e) => {
          this.setState({
            header: {
              ...this.state.header,
              backgroundColor: e.target.value
            }
          });
        }}
      />
      <div className="input-group-btn">
        <button 
          className="btn btn-default btn-md" 
          onClick={() => this.onShowColorPicker(this.state.header.backgroundColor || '#FFFFFF', 'header_backgroundColor')}
        >
          Pick color
        </button>
      </div>
    </div>
  </div>
</div>
<div className="col-md-4">
  <div className="form-group">
    <label>Text Color</label>
    <div className="input-group">
      <input 
        className="form-control"
        value={this.state.header.textColor || "#000000"}
       onChange={(e) => {
              this.setState({
                header: {
                  ...this.state.header,
                  textColor: e.target.value
                }
              });
            }}
      />
      <div className="input-group-btn">
        <button 
          className="btn btn-default btn-md" 
        onClick={() => this.onShowColorPicker(this.state.header.textColor || '#000000', 'header_textColor')}
        >
          Pick color
        </button>
      </div>
    </div>
  </div>
</div>
  </div>}
 {this.state.header.showHeader && <div className="row" style={{ marginTop: '16px' }}>
    <div className="col-md-12">
      <label className="question-label">Header Image</label>
      <ImageUploader
        maxImages={1}
        images={headerImages}
        StorageFolder="feedback"
        folderName="header"
        uploadFileToServer={this.props.uploadFileToServer}
        onChange={this.handleHeaderImageChange}
      />
    </div>
  </div>}
</PageSection>

{/* Footer Configuration - Fixed alignment */}
<PageSection title="Footer Configuration">
   <div className="row">
    <div className="col-md-4">
       <Input
        type="switch"
        label="Show Footer"
        value={this.state.footer.showFooter || false}
        onChange={(e) => {
          this.setState({
            footer: {
              ...this.state.footer,
              showFooter: e
            }
          });
        }}
      />
    </div>

  </div>
  {this.state.footer.showFooter && <div className="row">
    <div className="col-md-4">
      <Input
        type="text"
        label="Footer Text"
        placeholder="Enter footer text"
        value={this.state.footer.text || ""}
        onChange={(e) => {
          this.setState({
            footer: {
              ...this.state.footer,
              text: e
            }
          });
        }}
      />
    </div>
    <div className="col-md-4">
  <div className="form-group">
    <label>Background Color</label>
    <div className="input-group">
      <input 
        className="form-control"
        value={this.state.footer.backgroundColor || "#FFFFFF"}
        onChange={(e) => {
          this.setState({
            footer: {
              ...this.state.footer,
              backgroundColor: e.target.value
            }
          });
        }}
      />
      <div className="input-group-btn">
        <button 
          className="btn btn-default btn-md" 
          onClick={() => this.onShowColorPicker(this.state.footer.backgroundColor || '#FFFFFF', 'footer_backgroundColor')}
        >
          Pick color
        </button>
      </div>
    </div>
  </div>
</div>
    <div className="col-md-4">
  <div className="form-group">
    <label>Text Color</label>
    <div className="input-group">
      <input 
        className="form-control"
        value={this.state.footer.textColor || "#000000"}
       onChange={(e) => {
              this.setState({
                footer: {
                  ...this.state.footer,
                  textColor: e.target.value
                }
              });
            }}
      />
      <div className="input-group-btn">
        <button 
          className="btn btn-default btn-md" 
        onClick={() => this.onShowColorPicker(this.state.footer.textColor || '#000000', 'footer_textColor')}
        >
          Pick color
        </button>
      </div>
    </div>
  </div>
</div>
  </div>}
  {this.state.footer.showFooter && <div className="row" style={{ marginTop: '16px' }}>
    <div className="col-md-12">
      <label className="question-label">Footer Image</label>
      <ImageUploader
        maxImages={1}
        images={footerImages}
        StorageFolder="feedback"
        folderName="footer"
        uploadFileToServer={this.props.uploadFileToServer}
        onChange={this.handleFooterImageChange}
      />
    </div>
  </div>}
</PageSection>

        <PageSection title="Questions">
          <div className="questions-grid">
            {this.state.questions.map((question, questionIndex) => (
              <div key={questionIndex} className="question-card">
                <div className="question-header">
                  <h4>Question {questionIndex + 1}</h4>
                  <button
                    className="remove-question-btn"
                    onClick={() => this.removeQuestion(questionIndex)}
                  >
                    ×
                  </button>
                </div>
                <div className="question-field">
                  <Input
                    type="text"
                    label=""
                    placeholder="Enter your question"
                    value={question.question || ""}
                    onChange={(e) => this.updateQuestion(questionIndex, "question", e)}
                    isMandatory={true}
                  />

                  <Input
                    type="select"
                    label="Answer Type"
                    onChange={(value) => this.updateQuestion(questionIndex, "answerType", value)}
                    value={question.answerType || "text"}
                  >
                    <option value="text">Text</option>
                    <option value="phone">Phone No</option>
                    <option value="email">Email Id</option>
                    <option value="textarea">Textarea</option>
                    <option value="dropdown">Dropdown</option>
                    <option value="radio">Radio</option>
                    <option value="checkbox">Checkbox</option>
                    <option value="emoji">Emoji</option>
                    <option value="star">Star Rating</option>
                  </Input>
                </div>

                <div className="question-field">
                  <Input
                    type="switch"
                    label="Mandatory"
                    value={question.mandatory || false}
                    onChange={(e) => this.updateQuestion(questionIndex, "mandatory", e)}
                  />
                </div>

                {question.answerType === "star" && (
                  <div className="question-field">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <Input
                        type="number"
                        label="Number of Stars"
                        value={question.starCount || 5}
                        onChange={(e) => this.updateQuestion(questionIndex, "starCount", e)}
                      />
                    </div>
                    {this.renderStarRatingPreview(questionIndex)}
                  </div>
                )}

                {(question.answerType === "dropdown" ||
                  question.answerType === "radio" ||
                  question.answerType === "checkbox" ||
                  question.answerType === "emoji") && (
                    <>
                      {question.answerType === "emoji" ? (
                        <div className="question-field">
                          <label className="question-label">Select Emoji Options</label>

                          {question.options && question.options.length > 0 && (
                            <div className="selected-emojis">
                              {question.options.map((option, optionIndex) => (
                                <div key={optionIndex} className="selected-emoji-item">
                                  <span className="emoji-display">{option.label}</span>
                                  <span className="emoji-label">{option.value}</span>
                                  <button
                                    onClick={() => this.removeEmojiOption(questionIndex, optionIndex)}
                                    className="remove-emoji-btn"
                                  >
                                    ×
                                  </button>
                                </div>
                              ))}
                            </div>
                          )}

                          <button
                            className="add-emoji-btn"
                            onClick={() => this.toggleEmojiPicker(questionIndex)}
                          >
                            {this.state.showEmojiPicker[questionIndex] ? "Close Emoji Picker" : "+ Add Emoji"}
                          </button>

                          {this.state.showEmojiPicker[questionIndex] && (
                            <div className="emoji-picker-container">
                              <Input
                                type="text"
                                label=""
                                placeholder="Search emojis..."
                                value={this.state.emojiSearchTerm[questionIndex] || ""}
                                onChange={(e) => this.handleEmojiSearch(questionIndex, e)}
                              />
                              <div className="emoji-grid">
                                {this.emojiList
                                  .filter((item) =>
                                    item.label.toLowerCase().includes(
                                      (this.state.emojiSearchTerm[questionIndex] || "").toLowerCase()
                                    ) ||
                                    item.emoji.includes(this.state.emojiSearchTerm[questionIndex] || "")
                                  )
                                  .map((item, index) => (
                                    <div
                                      key={index}
                                      className="emoji-grid-item"
                                      onClick={() => this.addEmojiOption(questionIndex, item.emoji, item.label)}
                                      title={item.label}
                                    >
                                      <span className="emoji-grid-emoji">{item.emoji}</span>
                                      <span className="emoji-grid-label">{item.label}</span>
                                    </div>
                                  ))}
                              </div>
                            </div>
                          )}
                        </div>
                      ) : (
                        <>
                          <div className="question-field">
                            <button
                              className="add-option-btn"
                              onClick={() => this.addOption(questionIndex)}
                            >
                              + Add Option
                            </button>
                          </div>

                          <div className="question-field">
                            <label className="question-label">Options</label>
                            {question.options && question.options.map((option, optionIndex) => (
                              <div key={optionIndex} className="option-row">
                                <Input
                                  type="text"
                                  label=""
                                  placeholder="Label"
                                  value={option.label || ""}
                                  onChange={(e) =>
                                    this.updateOption(questionIndex, optionIndex, "label", e)
                                  }
                                />
                                <Input
                                  type="text"
                                  label=""
                                  placeholder="Value"
                                  value={option.value || ""}
                                  onChange={(e) =>
                                    this.updateOption(questionIndex, optionIndex, "value", e)
                                  }
                                />
                                <NewImageButton
                                  type={"delete"}
                                  label={""}
                                  onClick={() => this.removeOption(questionIndex, optionIndex)}
                                />
                              </div>
                            ))}
                          </div>
                        </>
                      )}
                    </>
                  )}
              </div>
            ))}

            <div
              className="question-card add-question-card"
              onClick={this.addQuestion}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '200px',
                cursor: 'pointer',
                border: '2px dashed #ddd',
                backgroundColor: '#fafafa',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#f0f0f0';
                e.currentTarget.style.borderColor = '#999';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#fafafa';
                e.currentTarget.style.borderColor = '#ddd';
              }}
            >
              <span style={{
                fontSize: '48px',
                color: '#000000',
                backgroundColor: '#efefff',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '80px',
                height: '80px',
                borderRadius: '50%',
                padding: '0'
              }}>
                <Icon type="add" />
              </span>
              <span style={{ marginTop: '8px', color: '#999', fontSize: '14px' }}>
                Add Question
              </span>
            </div>
          </div>
        </PageSection>
      </div>
    );
  };

  renderStep2 = () => {
    return (
      <PageSection title="">
        
      </PageSection>
    );
  };

  render() {
    const { currentStep } = this.state;
    const isStep1 = currentStep === 1;
    const isStep2 = currentStep === 2;

    const saveButtonLabel = isStep1 ? "Next" : "Save";
    const cancelButtonLabel = isStep1 ? "Cancel" : "Back";

    const handleSaveAction = this.onSave;
    const handleCancelAction = this.onCancel;

    return (
      <>
        <Page
          title={"Create Feedback Template"}
          showSaveButton={true}
          showCancelButton={true}
          processing={this.state.loading}
          onClick={(action) => {
            if (action === "cancel") {
              handleCancelAction();
            } else if (action === "save") {
              handleSaveAction();
            }
          }}
        >
          {isStep1 && this.renderStep1()}
          {isStep2 && this.renderStep2()}
        </Page>
        {this.renderColorPickerControl()}
      </>
    );
  }
}

export default FeedbackCreation;